import router from "@/router";

export default {
	init(router) {
		router.beforeEach((to, from, next) => {

			if (to.meta.isPublic)
				next();
			else {
				const isLoggedIn = this.getAccessToken();

				if (isLoggedIn) {

					/*
					 * if we don't have vuex in localStorage, that means we are on V2
					 * we should sign out the user if that is the case
					 */
					const isOldKitroVersion = !localStorage.getItem("vuex");
					if (isOldKitroVersion) {
						this.clearStorage();

						next("/sign-in");
						return;
					}

					next();
				}
				else
					next("/sign-in");

			}
		});
	},

	getAccessToken() {
		return localStorage.getItem(localStorage.getItem("refkey") + ".accessToken");
	},

	getIdToken() {
		return localStorage.getItem(localStorage.getItem("refkey") + ".idToken");
	},

	isSessionActive() {
		if (this.getAccessToken() === null)
			window.location = "/sign-in";
		else
			return true;

	},

	get(field) {
		return localStorage.getItem(localStorage.getItem("refkey") + "." + field);
	},

	set(field, value) {
		localStorage.setItem(localStorage.getItem("refkey") + "." + field, value);
	},

	clearStorage() {
		// clear filters
		const language = localStorage.getItem("language") || "en",
			vuex = JSON.parse(localStorage.getItem("vuex")),
			branding = vuex?.branding;

		// delete every key except the language and branding
		localStorage.clear();
		localStorage.setItem("language", language);
		if (branding)
			localStorage.setItem("vuex", JSON.stringify({branding: branding}));

	},

	logout() {
		this.clearStorage();
		router.push({path: "/sign-in"});
	}
};
